module.exports = __webpack_public_path__ + "static/media/logo-globe.5c21e4c5.svg";